module.exports = __webpack_public_path__ + "static/media/img04.acc8dfd3.png";